import React, { useState, useEffect } from 'react';
import { InputNumber } from 'antd';
import { isNumber } from '@utils/currency.js';

export default function ValueDriverNumberInput({
  value: valueInProps = null,
  onChange,
  onValueFormat,
  config = {},
  ...props
}) {
  const valueInForm = isNumber(valueInProps)
    ? Number(valueInProps)
    : typeof valueInProps === 'string'
    ? valueInProps.replace(/,/g, '')
    : valueInProps;

  const [currentValue, changeCurrentValue] = useState(valueInForm);
  const { magnification = 1, negative = false } = config;

  useEffect(() => {
    changeCurrentValue(valueInForm);
  }, [valueInForm]);

  useEffect(() => {
    if (currentValue !== valueInForm && typeof onChange === 'function') {
      onChange(currentValue);
    }
  }, [currentValue]);

  const handleChange = (e) => {
    let newValue = null;
    if (e === '-') {
      newValue = e;
    }

    if (isNumber(e)) {
      newValue = Math.floor(e);
    }

    changeCurrentValue(newValue);
  };

  const valueParse = (value) => {
    if (value === '-' || value === '0-') {
      return '-';
    }

    if (!value) {
      return '';
    }

    let isNegative;

    if (value.startsWith('-')) {
      isNegative = true;
    }

    const replacedValue = value.replace(/[^0-9]/g, '');

    const result = Number(replacedValue) * magnification;
    if (result === 0 && isNegative) {
      return '-';
    }

    if (!replacedValue) {
      return '';
    }

    return isNegative ? 0 - result : result;
  };

  const valueFormatter = (value) => {
    if (value === '-') {
      return '-';
    }
    if (!isNumber(value)) {
      return '';
    }

    const result = `${Math.floor(value / magnification)}`.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ',',
    );
    typeof onValueFormat === 'function' && onValueFormat(result);
    return result;
  };

  // const onPressEnter = (e) => {
  //   typeof props.onPressEnter === 'function' &&
  //     props.onPressEnter(e, currentValue);
  // };

  return (
    <InputNumber
      className="dd-number-input-left"
      min={negative ? undefined : 0}
      {...props}
      formatter={valueFormatter}
      parser={valueParse}
      value={currentValue}
      onChange={handleChange}
      // onPressEnter={onPressEnter}
    />
  );
}
